import {
    AbutmentsInfoState,
    AvailableToReturnState,
    ClinicalConditionState,
    ComplaintState,
    ComplaintTypeState,
    GeneralComplaintState,
    GeneralInfoState,
    GuestInfoState,
    InstrumentInfoState, MetadataState,
    PatientInfoState,
    ReplacementsState,
    SecondaryDeviceState,
    ShippingInfoState,
    TreatmentDatesState,
} from './types'

const defaultGuestInfo: GuestInfoState = {
    telephone: '',
    country: '', 
    customerNumber: '',
    email: ''
}

const defaultGeneralInfo: GeneralInfoState = {
    contactName: '',
    isAcknowledged: false,
}

const defaultGeneralComplaint: GeneralComplaintState = {
    selectedProduct: undefined,
    isProductUnknown: false,
    isBatchOrLotNumberKnown: '',
    batchOrLotNumber: '',
    wasProductPlaced: '',
    wasPatientInvolved: '',
    isReplacementNeeded: '',
    productType: '',
    wasOpenedOrDropped: '',
    wasAnotherImplantPlaced: '',
}

const defaultTreatmentDates: TreatmentDatesState = {
    dateOfTreatment: null,
    wasImplantLoaded: '',
    dateOfImplantLoading: null,
    wasThereASecondSurgery: '',
    dateOfSecondSurgery: null,
    wasProductRemoved: '',
    dateProductWasRemoved: null,
}

const defaultPatientInfo: PatientInfoState = {
    patientId: '',
    patientAge: null,
    patientWeight: null,
    patientWeightUnit: 'lbs',
    patientSex: '',
    patientProfile: {
        BRUXER: false,
        DIABETIC: false,
        SMOKER: false,
        NONE: false,
        UNKNOWN: false,
        OTHER: false,
    },
    patientProfileExplanation: '',
    hygiene: '',
    boneQuality: '',
    boneQualityExplanation: '',
    utn: '',
    fdi: '',
    didDeviceContributeToInjury: '',
    currentPatientStatus: '',
    typeOfInjury: '',
    typeOfInjuryExplanation: '',
}

const defaultComplaintType: ComplaintTypeState = {
    dateOfOccurrence: null,
    location: '',
    complaintType: '',
    estheticExplanation: '',
    otherExplanation: '',
    attachmentIds: [],
}

const defaultClinicalCondition: ClinicalConditionState = {
    clinicalCondition: '',
    prolongedSurgeryExplanation: '',
    prolongedTreatmentExplanation: '',
    permanentImpairmentExplanation: '',
    otherExplanation: '',
    hasPainDisappeared: '',
    hasNumbnessDisappeared: '',
    wereNerveSymptomsAlleviated: '',
}

const defaultAbutmentsInfo: AbutmentsInfoState = {
    implantBrandUsed: '',
    articleNumber: '',
    batchOrLotNumber: '',
}

const defaultInstrumentInfo: InstrumentInfoState = {
    numberOfTimesUsed: null,
    ageOfDevice: null,
}

const defaultAvailableToReturn: AvailableToReturnState = {
    canItemBeReturned: '',
    confirmDecontamination: false,
    reasonItemCannotBeReturned: '',
    attachmentId: undefined,
}

const defaultShippingInfo: ShippingInfoState = {
    customer: undefined,
    shippingAddress: undefined,
    hasAcceptedTerms: false,
    signature: '',
}

const defaultReplacements: ReplacementsState = {
    selectedMainProductReplacement: undefined,
    selectedSecondaryDeviceReplacement: undefined,
}

const defaultSecondaryDevice: SecondaryDeviceState = {
    hasSecondaryDevice: '',
    hasSecondaryDeviceComplaint: '',
    isReplacementNeeded: '',
    selectedProduct: undefined,
    isBatchOrLotNumberKnown: '',
    batchOrLotNumber: '',
}

const defaultMetadata: MetadataState = {
    isInitialComplaint: true,
    complaintWithCustomerData: false,
    complaintOnSecondaryDevice: false,
    complaintWithPatientAndTreatmentData: false
}

const defaultComplaint: ComplaintState = {
    generalInfo: defaultGeneralInfo,
    guestInfo: defaultGuestInfo,
    generalComplaint: defaultGeneralComplaint,
    treatmentDates: defaultTreatmentDates,
    patientInfo: defaultPatientInfo,
    complaintType: defaultComplaintType,
    clinicalCondition: defaultClinicalCondition,
    abutmentsInfo: defaultAbutmentsInfo,
    instrumentInfo: defaultInstrumentInfo,
    availableToReturn: defaultAvailableToReturn,
    secondaryDevice: defaultSecondaryDevice,
    replacements: defaultReplacements,
    shippingInfo: defaultShippingInfo,
    metadata: defaultMetadata,
}

export const getDefaultGeneralInfo = () => ({
    ...defaultGeneralInfo,
})

export const getDefaultGuestInfo = () => ({
    ...defaultGuestInfo,
})

export const getDefaultGeneralComplaint = () => ({
    ...defaultGeneralComplaint,
})

export const getDefaultTreatmentDates = () => ({
    ...defaultTreatmentDates,
})

export const getDefaultPatientInfo = () => ({
    ...defaultPatientInfo,
})

export const getDefaultComplaintType = () => ({
    ...defaultComplaintType,
})

export const getDefaultClinicalCondition = () => ({
    ...defaultClinicalCondition,
})

export const getDefaultAbutmentsInfo = () => ({
    ...defaultAbutmentsInfo,
})

export const getDefaultInstrumentInfo = () => ({
    ...defaultInstrumentInfo,
})

export const getDefaultAvailableToReturn = () => ({
    ...defaultAvailableToReturn,
})

export const getDefaultShippingInfo = () => ({
    ...defaultShippingInfo,
})

export const getDefaultReplacements = () => ({
    ...defaultReplacements,
})

export const getDefaultMetadata = (): MetadataState => ({
    ...defaultMetadata,
})

export const getDefaultSecondaryDevice = () => ({
    ...defaultSecondaryDevice,
})

export const getDefaultComplaint = (): ComplaintState => ({
    ...defaultComplaint,
})
